import React, { memo } from 'react'
import { Bullet } from 'components/atoms/icons'
import { IFullStop } from 'types'
import { DISPLAY } from 'constants/display'

interface IMarketplaceStopDetailsDisplay {
  stop: IFullStop
}

export const MarketplaceStopDetailsDisplay = memo<IMarketplaceStopDetailsDisplay>(({ stop }) => {
  const { info } = stop || {}
  const { commodity, genericCommodity, palletCount, weight } = info || {}
  return (
    <span>
      <span>{genericCommodity || commodity || DISPLAY.empty}</span>
      <Bullet />
      <span>{weight ? weight.toLocaleString() : DISPLAY.empty} lbs</span>
      <Bullet />
      <span>{`${palletCount || DISPLAY.empty} pallets`} </span>
    </span>
  )
})
